<template>
  <v-app id="app">
    <NoJs />
    <v-main class="lt-md:bg-white md:bg-[#050505]">
      <div class="lt-md:hidden bg-gradient__wrapper">
        <div class="bg-gradient bg-gradient__dark">
          <div class="bg-gradient__shape bg-gradient__shape--1"></div>
          <div class="bg-gradient__shape bg-gradient__shape--2"></div>
        </div>
        <div class="bg-gradient__noise"></div>
      </div>
      <v-container class="h-full lt-md:px-0">
        <div class="h-full flex-center">
          <div class="md:w-450px w-full">
            <v-card class="pa-8 md:px-10" rounded="lg" :flat="mobile">
              <div class="mb-4 flex gap-1 items-center">
                <Logo size="30" />
                <div class="text-4 font-bold">Orie</div>
              </div>

              <slot></slot>

              <v-card-actions
                class="mt-4 text-3 gap-2 px-0 lt-md:fixed lt-md:bottom-4 lt-md:w-full"
              >
                <a class="link" :href="links.privacy" target="_blank"
                  >Privacy</a
                >
                <a class="link" :href="links.terms" target="_blank">Terms</a>
              </v-card-actions>
            </v-card>
          </div>
        </div>
      </v-container>
    </v-main>
    <!-- <AcceptTerms /> -->
  </v-app>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useDisplay } from "vuetify";
import AcceptTerms from "~/components/account-alerts/AcceptTerms.vue";

export default defineComponent({
  components: { AcceptTerms },
  setup() {
    const { links } = useAppConfig();
    const { mobile } = useDisplay();

    return {
      links,
      mobile,
    };
  },
});
</script>

<style scoped>
/* ============================================
   Background Gradient System
   ============================================ */

/* Main wrapper for the gradient background */
.bg-gradient__wrapper {
  background: #141414;
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

/* Base gradient container */
.bg-gradient {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* Blurred gradient background */
.bg-gradient__dark {
  -webkit-filter: blur(250px);
  filter: blur(250px);
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

/* Noise texture overlay */
.bg-gradient__noise {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url(/img/noise.png);
  background-repeat: repeat;
  background-size: 100px;
}

/* ============================================
   Animated Gradient Shapes
   ============================================ */

/* Base shape styles */
.bg-gradient__shape {
  position: absolute;
  border-radius: 100%;
  mix-blend-mode: lighten;

  /* Animation properties */
  -webkit-animation-duration: 20s;
  animation-duration: 20s;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-timing-function: cubic-bezier(0.1, 0, 0.9, 1);
  animation-timing-function: cubic-bezier(0.1, 0, 0.9, 1);
}

/* Left bottom shape - Indigo */
.bg-gradient__shape--1 {
  bottom: 0;
  left: 0;
  width: 700px;
  height: 700px;
  background: indigo;
  -webkit-transform: translate(-30%, 40%);
  transform: translate(-30%, 40%);
  -webkit-animation-name: gradientShapeAnimation1;
  animation-name: gradientShapeAnimation1;
}

/* Right top shape - Orange */
.bg-gradient__shape--2 {
  top: 0;
  right: 0;
  width: 600px;
  height: 600px;
  background: #ff4400;
  -webkit-transform: translate(20%, -40%);
  transform: translate(20%, -40%);
  -webkit-animation-name: gradientShapeAnimation2;
  animation-name: gradientShapeAnimation2;
}

/* ============================================
   Accessibility & Motion Preferences
   ============================================ */

@media (prefers-reduced-motion) {
  .bg-gradient__shape--1,
  .bg-gradient__shape--2 {
    -webkit-animation-name: none;
    animation-name: none;
  }
}

/* ============================================
   Keyframe Animations
   ============================================ */

@keyframes gradientShapeAnimation1 {
  0%,
  100% {
    -webkit-transform: translate(-30%, 40%) scale(1);
    transform: translate(-30%, 40%) scale(1);
  }
  50% {
    -webkit-transform: translate(-20%, 30%) scale(1.1);
    transform: translate(-20%, 30%) scale(1.1);
  }
}

@keyframes gradientShapeAnimation2 {
  0%,
  100% {
    -webkit-transform: translate(20%, -40%) scale(1);
    transform: translate(20%, -40%) scale(1);
  }
  50% {
    -webkit-transform: translate(30%, -30%) scale(1.1);
    transform: translate(30%, -30%) scale(1.1);
  }
}

/* WebKit prefixes for animations */
@-webkit-keyframes gradientShapeAnimation1 {
  0%,
  100% {
    -webkit-transform: translate(-30%, 40%) scale(1);
    transform: translate(-30%, 40%) scale(1);
  }
  50% {
    -webkit-transform: translate(-20%, 30%) scale(1.1);
    transform: translate(-20%, 30%) scale(1.1);
  }
}

@-webkit-keyframes gradientShapeAnimation2 {
  0%,
  100% {
    -webkit-transform: translate(20%, -40%) scale(1);
    transform: translate(20%, -40%) scale(1);
  }
  50% {
    -webkit-transform: translate(30%, -30%) scale(1.1);
    transform: translate(30%, -30%) scale(1.1);
  }
}
</style>
